class LayoutService {
  getHeader() {
    return JSON.parse(localStorage.getItem("layouts")).header;
  }
  getBanners() {
    return JSON.parse(localStorage.getItem("layouts")).banners;
  }
}

export default new LayoutService();
